import { useEffect } from 'react'
import type { RestaurantMenu } from '../api/types'
import { pickReadableTextColor } from '../lib/contrast'
import { getRadiusTokens } from '../lib/buttonStyle'

export function useBranding(menu: RestaurantMenu | undefined) {
  useEffect(() => {
    if (!menu) return
    const root = document.documentElement.style

    root.setProperty('--brand-primary', menu.primary_color)
    root.setProperty('--brand-accent', menu.accent_color)
    root.setProperty('--brand-accent-text', pickReadableTextColor(menu.accent_color))
    root.setProperty('--bg-page', menu.background_color)
    root.setProperty('--heading-font', `"${menu.heading_font}"`)
    root.setProperty('--body-font', `"${menu.body_font}"`)

    const radius = getRadiusTokens(menu.button_style)
    root.setProperty('--card-radius', radius.card)
    root.setProperty('--chip-radius', radius.chip)
    root.setProperty('--sheet-radius', radius.sheet)
  }, [
    menu?.primary_color,
    menu?.accent_color,
    menu?.background_color,
    menu?.heading_font,
    menu?.body_font,
    menu?.button_style,
  ])
}
